import { TranslationService } from '../../../../services/translation.service';

function PageIntroduction({ heading, text = undefined, requiredText = false }: { heading: string; text?: string | undefined; requiredText?: boolean }) {
  const formsRequiredFieldsMessage = TranslationService.get('common.formsrequiredfieldsmessage');

  return (
    <div className="mb-4 mb-md-5">
      <h1>{heading}</h1>
      {text && <p className={requiredText && formsRequiredFieldsMessage ? '' : 'mb-0'}>{text}</p>}
      {requiredText && formsRequiredFieldsMessage && <p className="mb-0">{formsRequiredFieldsMessage}</p>}
    </div>
  );
}

export default PageIntroduction;
